<template>
    <div>
        <div v-if="filteredAwards.length > 0" class="input-container">
            <div class="input-box"><input type="text" placeholder="Quick Search"><span class="fa fa-search"></span></div>
        </div>
        <div class="list-container">
            <div class="table">
                <div v-if="filteredAwards.length > 0" class="row">
                    <div class="cell max-width-50"><a href="" class="point-up">Award<span class="fa fa-angles-down"></span></a></div>
                    <div class="cell"><a href="" class="point-down">Stamp Value</a></div>
                    <!--<div class="cell align-center"><a href="" class="point-down">Times Earned</a></div>-->
                    <div v-if="!inKidMode" class="cell align-right"></div>
                </div>
                <div v-for="award in filteredAwards" :key="`award-${ award.id }`" class="row">
                    <div class="cell max-width-50">{{ award.name }}</div>
                    <div class="cell"><span class="status-bubble neutral-bg">{{ award.stamps_required }}</span></div>
                    <div v-if="!inKidMode" class="cell align-right">
                        <div class="buttons"><delete-button @deleted="deleteAward(award)">
                            <a :href="`/passport/awards/${ award.id }/edit`" class="neutral-bg">Update<span class="fa fa-wrench"></span></a>
                        </delete-button></div>
                    </div>
                </div>
                <nothing-here v-if="!filteredAwards.length" :is-filtered="search.length > 0"></nothing-here>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {

    props: [ 'awards' ],

    data() {
        return {
            search: '',
        };
    },

    computed: {

        ...mapGetters([ 'inKidMode' ]),

        filteredAwards() {
            if (!this.search || this.search.length === 0) {
                return this.awards;
            }

            const search = this.search.toLowerCase();
            return _.filter(this.awards, award => award.name.toLowerCase().indexOf(search) !== -1 ||
                award.description.toLowerCase().indexOf(search) !== -1
            );
        }

    },

    methods: {

        async deleteAward(award) {
            await axios.post('/passport/awards/' + award.id, { _method: 'DELETE' });

            window.location.reload();
        }

    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/passport/AwardsList.vue